import React, { Fragment } from "react";
import { Button, Col, Form, Modal, Row, Icon, InputNumber, Input, Switch } from "antd";
import { FormattedMessage } from "react-intl";
import Navigation from "@components/custom/Navigation";
import { WidgetType } from "@models/widget";
import { WidgetItemPreview } from "@components/widgets/Preview";
import { WidgetItem } from "@models/widget";
import WidgetItemVideoSelection from "@components/widgets/widgetItemForms/WidgetItemVideoSelection";
import WidgetWideItemSelection from "@components/widgets/widgetItemForms/WidgetWideItemSelection";
import WidgetItemImageSelection from "@components/widgets/widgetItemForms/WidgetItemImageSelection";
import WidgetItemPersonSelection from "@components/widgets/widgetItemForms/WidgetItemPersonSelection";
import WidgetItemCategorySelection from "@components/widgets/widgetItemForms/WidgetItemCategorySelection";
import WidgetItemTagSelection from "@components/widgets/widgetItemForms/WidgetItemTagSelection";
import WidgetItemChannelSelection from "@components/widgets/widgetItemForms/WidgetItemChannelSelection";
import WidgetItemTeaserVideoSelection from "@components/widgets/widgetItemForms/WidgetItemTeaserVideoSelection";
import FranchiseItem from "@components/widgets/widgetItemForms/FranchiseItem";
import { SelectionMode } from "../../models";
import DatePicker from "react-datepicker2";
import moment from "moment-jalaali";
import { showDate } from "../../utils";


interface PropsShape {
  item: WidgetItem | null;
  type: any;
  form: any;
}

/**
 * This class handles Widget Items Form
 * In all widget's types except carousels navigation is handles in the items form
 * Poster has an extra option : width
 * Carousels are VideoContent selection
 * Poster and sliders are image selections
 */
class ItemForm extends React.Component<PropsShape> {
  navigationRef = null;

  constructor(props) {
    super(props);
    const { item } = this.props;
    this.state = {
      visible: false,
      title: item?.title || "",
      width: item?.width || "",
      text: item?.text || "",
      summery: item?.summery || "",
      navigation_button: item?.navigation_button || null,
      navigation_configuration: item?.navigation_configuration || null,
      image_file: item?.image_file || null,
      cover_image_file: item?.cover_image_file || null,
      poster_image_file: item?.poster_image_file || null,
      mobile_image_file: item?.mobile_image_file || null,
      logo_image_file: item?.logo_image_file || null,
      video_content: item?.video_content || null,
      person: item?.person || null,
      category: item?.category || null,
      tag: item?.tag || null,
      channel: item?.channel || null,
      video_file: item?.video_file || null,
      poster_file: item?.poster_file || null,
      iran_access: item?.iran_access || null,
      show_play_button: item && item.show_play_button ? item.show_play_button : false,
      schedule_text: item && item.schedule_text ? item.schedule_text : '',
      count_down: (item?.count_down && item.count_down != "0001-01-01T00:00:00") ? moment(showDate(item.count_down)) : null,
    };
  }

  /**
   * This function check if the widget has configuration return its values
   * return an object or null
   * Null means that there is a validation issue in the Navigation Component
   */
  getNavigationConfig = () => {
    if (this.navigationRef) {
      const navigationConfig = this.navigationRef.getConfig();
      if (navigationConfig) {
        return navigationConfig;
      } else {
        return null;
      }
    } else {
      return {};
    }
  };

  handleSubmit = () => {
    const navigationConfig = this.getNavigationConfig();

    this.props.form.validateFields((err, values) => {
      if (!err && !!navigationConfig) {
        const data = {
          ...values,
          ...navigationConfig
        };

        if (this.props.item) {
          this.props.onEdit(this.props.index, data);
        } else {
          this.props.onAdd(data);
        }

        this.setState({
          ...data,
          visible: false
        });
      }
    });
  };

  showModal = () => {
    this.setState({
      visible: true
    });
  };

  hideModal = () => {
    this.setState({
      visible: false
    });
  };

  visibleView() {
    const { item, key, index, moveCard, onDelete } = this.props;
    if (!item) {
      return (
        <Button
          type="link"
          onClick={this.showModal}
          style={{ width: "auto" }}
        >
          <FormattedMessage id="app.add_item" defaultMessage={`Add Item`} />
          <Icon type="plus" />
        </Button>
      );
    } else {
      return (
        <WidgetItemPreview
          item={item}
          key={key}
          id={`${index}`}
          index={index}
          type={this.props.type}
          moveCard={moveCard}
        >
          <Icon
            type="edit"
            onClick={e => {
              e.preventDefault();
              this.showModal();
            }}
          />
          <Icon type="delete" onClick={() => onDelete(index)} />
        </WidgetItemPreview>
      );
    }
  }

  hasNavigationConfig = () => {
    const { type } = this.props;
    return type == WidgetType.MAIN_SLIDER || type == WidgetType.POSTER;
  };

  hasIranAccess = () => {
    const { type } = this.props;
    return type == WidgetType.MAIN_SLIDER;
  };

  hasTextField = () => {
    const { type } = this.props;
    return type == WidgetType.MAIN_SLIDER;
  };

  hasName = () => {
    const { type } = this.props;
    return type == WidgetType.FRANCHISE;
  }

  hasLogoImage = () => {
    const { type } = this.props;
    return type == WidgetType.MAIN_SLIDER || type == WidgetType.EXCLUSIVE;
  }

  getFormItemsBaseOnWidgetType = () => {
    const { form, type, item } = this.props;

    switch (type) {
      case WidgetType.MAIN_SLIDER:
        return (
          <>
            <WidgetItemImageSelection
              form={form}
              selectedImage={this.state.image_file}
            />
            <WidgetItemImageSelection
              form={form}
              label="app.select_mobile_image"
              field="mobile_image_file"
              selectedImage={this.state.mobile_image_file}
            />
          </>
        );

      case WidgetType.POSTER:
        return (
          <WidgetItemImageSelection
            form={form}
            selectedImage={this.state.image_file}
          />
        );

      case WidgetType.PROMOTED_CAROUSEL:
      case WidgetType.REQULAR_CAROUSEL:
        return (
          <WidgetItemVideoSelection
            form={form}
            selectedVideo={item ? item.video_content : this.state.video_content}
          />
        );
      case WidgetType.WIDE_SLIDER:
        return (
          <WidgetWideItemSelection
            form={form}
            selectedVideo={item ? item.video_content : this.state.video_content}
            selectedImage={this.state.image_file}
          />
        );
      case WidgetType.ARTIST_CAROUSEL:
        return (
          <WidgetItemPersonSelection
            form={form}
            selectedPerson={item ? item.person : this.state.person}
          />
        );
      case WidgetType.CATEGORY_CAROUSEL:
        return (
          <WidgetItemCategorySelection
            form={form}
            mode={SelectionMode.DEFAULT}
            selectedCategory={item ? item.category : this.state.category}
          />
        );
      case WidgetType.TAG_CAROUSEL:
        return (
          <WidgetItemTagSelection
            form={form}
            selectedTag={item ? item.tag : this.state.tag}
          />
        );
      case WidgetType.LIVE_CHANNEL:
        return (
          <WidgetItemChannelSelection
            form={form}
            selectedChannel={item ? item.channel : this.state.channel}
          />
        );
      case WidgetType.TEASER_VIDEO:
        return (
          <WidgetItemTeaserVideoSelection
            form={form}
            selectedVideoFile={item ? item.video_file : this.state.video_file}
            selectedPoster={item ? item.poster_file : this.state.poster_file}
          />
        );
      case WidgetType.EXCLUSIVE:
        return (
          <>
            <WidgetItemImageSelection
              form={form}
              label="app.select_poster_image"
              field="poster_image_file"
              selectedImage={this.state.poster_image_file}
            />

          <WidgetItemImageSelection
              form={form}
              label="app.select_cover_image"
              field="cover_image_file"
              selectedImage={this.state.cover_image_file}
            />

            <WidgetItemVideoSelection
              form={form}
              selectedVideo={item ? item.video_content : this.state.video_content}
            />

            <Form.Item
              label={<FormattedMessage id="app.description" defaultMessage={`summery`} />}
            >
              {form.getFieldDecorator("summery", {
                initialValue: this.state.summery,
              })(<Input rows={2}  />)}
            </Form.Item>
          </>
        );

      case WidgetType.FRANCHISE:
      case WidgetType.PROMOTED:
      case WidgetType.VITRINE:
        return (
          <FranchiseItem
            form={form}
            item={item}
          />
        );
    }
  };

  onChangeDate = (type, date) => {
    this.setState(prev => ({
      ...prev,
      [type]: date
    }));
  }

  render() {
    const { form } = this.props;
    const { getFieldDecorator } = form;
    return (
      <Fragment>
        {this.visibleView()}

        <Modal
          className="form-modal"
          visible={this.state.visible}
          destroyOnClose={true}
          closable={false}
          maskClosable={false}
          getContainer={document.querySelector(".form-wrapper")}
          mask={false}
          footer={[
            <Button key="back" onClick={() => this.hideModal()}>
              <FormattedMessage id="app.cancel" defaultMessage={`Cancel`} />
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={this.handleSubmit}
            >
              <FormattedMessage id="app.save" defaultMessage={`Save`} />
            </Button>
          ]}
        >
          <Form>
            {this.hasLogoImage() && (
              <WidgetItemImageSelection
                form={form}
                label="app.select_logo_image"
                field="logo_image_file"
                selectedImage={this.state.logo_image_file}
                required={this.props.type !== WidgetType.MAIN_SLIDER}
              />
            )}

            {this.getFormItemsBaseOnWidgetType()}

            {this.hasName() && (
              <>
                <Col span={12}>
                  <Form.Item
                    label={<FormattedMessage id="Persian Name" defaultMessage={`Persian Name`} />}
                  >
                    {form.getFieldDecorator("persian_name", {
                      initialValue: this.state.persian_name,
                    })(
                      <Input />
                    )}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label={<FormattedMessage id="English Name" defaultMessage={`English Name`} />}
                  >
                    {form.getFieldDecorator("english_name", {
                      initialValue: this.state.english_name,
                    })(
                      <Input />
                    )}
                  </Form.Item>
                </Col>
              </>
            )}

            {this.props.type == WidgetType.POSTER && (
              <Row>
                <Col span={24}>
                  <Form.Item label={<FormattedMessage id="app.width" defaultMessage={`Width`} />}>
                    {getFieldDecorator("width", {
                      initialValue: this.state.width,
                      rules: [
                        {
                          required: true,
                          message: (
                            <FormattedMessage
                              id="app.width_is_required"
                              defaultMessage={`width is required!`}
                            />
                          )
                        }
                      ]
                    })(<InputNumber max={12} min={1} />)}
                  </Form.Item>
                </Col>
              </Row>
            )}
          </Form>

          {/*====================Navigation Component========================*/}
          {this.hasNavigationConfig() && (
            <div>
              <Navigation
                wrappedComponentRef={ref => (this.navigationRef = ref)}
                navigation_configuration={this.state.navigation_configuration}
                navigation_button={this.state.navigation_button}
                required={true}
                hasButtonConfig={true}
              />
            </div>
          )}

          {this.props.type == WidgetType.MAIN_SLIDER && (
            <>
              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item label={<FormattedMessage id="app.title" defaultMessage={`Title`} />}>
                    {getFieldDecorator("title", {
                      initialValue: this.state.title,
                    })(<Input />)}
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    label={<FormattedMessage id="app.description" defaultMessage={`Description`} />}>
                    {getFieldDecorator("text", {
                      initialValue: this.state.text || "",
                    })(<Input text={this.state.text} />)}
                  </Form.Item>
                </Col>
              </Row>

            <Col span={12}>
              <Form.Item
                label={<FormattedMessage id="schedule_text" defaultMessage={`schedule text`} />}>
                {getFieldDecorator("schedule_text", {
                  initialValue: this.state.schedule_text || "",
                })(<Input text={this.state.schedule_text} />)}
              </Form.Item>
            </Col>

            <Form.Item label={<FormattedMessage id="count_down" defaultMessage={`count down`} />}>
              {getFieldDecorator("count_down", {
                initialValue: moment(this.state.count_down),
              })(<Input type={`hidden`} />)}
              <DatePicker
                isGregorian={false}
                timePicker={true}
                value={this.state.count_down}
                onChange={(date) => this.onChangeDate('count_down', date)}
              />{" "}
            </Form.Item>

            <Row gutter={8}>
              <Col span={12}>
                <Form.Item className={'align-left'} label={<FormattedMessage id="show_play_button" defaultMessage={`show play button`} />}>
                  {getFieldDecorator("show_play_button", {
                    initialValue: this.state.show_play_button,
                  })(<Switch defaultChecked={this.state.show_play_button} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item className={'align-left'} label={<FormattedMessage id="iran_access" defaultMessage={`Iran Access`} />}>
                  {getFieldDecorator("iran_access", {
                    initialValue: this.state.iran_access,
                  })(<Switch defaultChecked={this.state.iran_access} />)}
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
        </Modal>
      </Fragment>
    );
  }
}

const WrappedSliderItemPopUp = Form.create({ name: "widget-item-form" })(
  ItemForm
);
export default WrappedSliderItemPopUp;
